import styled from 'styled-components';
import { overlineLabel, cardSurface } from '@/styles/mixins';

export const TableRoot = styled.div`
  ${cardSurface}
  overflow: hidden;
`;

export const TableScroll = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  margin: 0;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const Thead = styled.thead`
  th {
    ${overlineLabel}
    background-color: ${({ theme }) => theme.colors.primary50};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
    white-space: nowrap;
    text-align: left;
  }

  th.is-numeric {
    text-align: right;
  }

  th.is-center {
    text-align: center;
  }
`;

export const Tbody = styled.tbody`
  tr {
    transition: background-color ${({ theme }) => theme.transitions.fast};
  }

  tr.is-clickable {
    cursor: pointer;
  }

  tr.is-clickable:hover {
    background-color: ${({ theme }) => theme.colors.primary50};
  }

  tr.is-selected {
    background-color: ${({ theme }) => theme.colors.primary50};
  }

  td {
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
    vertical-align: middle;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
  }

  td.is-numeric {
    text-align: right;
    font-family: ${({ theme }) => theme.fonts.mono};
  }

  td.is-center {
    text-align: center;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const EmptyRow = styled.div`
  padding: ${({ theme }) => `${theme.spacing[10]} ${theme.spacing[6]}`};
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const SortableHeader = styled.button`
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  user-select: none;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 2px;
  }

  svg {
    opacity: 0.6;
  }
`;

export const SelectCell = styled.td`
  width: 2.5rem;
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`} !important;

  .form-check {
    margin: 0;
    padding-left: 1.5rem;
  }
`;

